/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};

  function getStepElements() {
    return document.querySelectorAll('.selection-step');
  }

  function showStep(stepNumber) {
    var steps = getStepElements();
    var stepId = 'step-' + stepNumber;

    steps.forEach(function (el) {
      if (el.id === stepId) {
        el.classList.remove('hidden-step');
      } else {
        el.classList.add('hidden-step');
      }
    });

    var scrollContainer = document.getElementById('custom-scrollbar');
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  }

  function updateTitle(step, ctx) {
    var titleEl = document.getElementById('steps-title');
    if (!titleEl) {
      return;
    }
    var titles = (Config && Config.STEP_TITLES) || {};
    var lensStep = Config.STEPS && Config.STEPS.LENS_TYPE;
    var byUsage = (Config && Config.STEP_TITLE_LENS_SELECTION_BY_USAGE) || {};
    var usage = ctx && ctx.usage;
    var override =
      step === lensStep && usage && typeof byUsage[usage] === 'string' ? byUsage[usage] : null;
    var text = override || titles[step] || 'Choose Your Usage';
    titleEl.textContent = text;
  }

  function updateButtons(step, totalSteps) {
    var prevButton = document.getElementById('prev-step');
    var nextButton = document.getElementById('next-step');
    var saveButton = document.getElementById('save-lens-data');
    var usageStep = (Config.STEPS && Config.STEPS.USAGE) || 1;
    var summaryStep = totalSteps || 7;

    if (prevButton) {
      if (step === usageStep) {
        prevButton.classList.add('hidden-step');
      } else {
        prevButton.classList.remove('hidden-step');
      }
    }

    if (nextButton) {
      nextButton.style.display = step === summaryStep ? 'none' : 'block';
    }

    if (saveButton) {
      saveButton.style.display = step === summaryStep ? 'flex' : 'none';
    }
  }

  window.OletLens.StepsModule = {
    showStep: showStep,
    updateTitle: updateTitle,
    updateButtons: updateButtons,
  };
})();
